export default __webpack_public_path__ + "static/media/anti-slip_blue_jade.05827e44.webp";